/**
 * OMNIVASO i18n Module — German (de)
 * Hand-curated. All keys must mirror en.js exactly.
 */
const de = {
    nav: {
        home:            'Startseite',
        shop:            'Shop',
        cart:            'Warenkorb',
        search:          'Suche',
        articles:        'Artikel',
        blog:            'Blog',
        about:           'Über uns',
        contact:         'Kontakt',
        account:         'Mein Konto',
        orders:          'Meine Bestellungen',
        login:           'Anmelden',
        logout:          'Abmelden',
        openMenu:        'Menü öffnen',
        closeMenu:       'Menü schließen',
        skipToContent:   'Zum Inhalt springen',
    },

    actions: {
        readMore:        'Mehr lesen',
        viewAll:         'Alle anzeigen',
        learnMore:       'Mehr erfahren',
        back:            'Zurück',
        close:           'Schließen',
        save:            'Speichern',
        cancel:          'Abbrechen',
        submit:          'Absenden',
        confirm:         'Bestätigen',
        delete:          'Löschen',
        edit:            'Bearbeiten',
        add:             'Hinzufügen',
        remove:          'Entfernen',
        search:          'Suchen',
        reset:           'Zurücksetzen',
        next:            'Weiter',
        previous:        'Zurück',
        loading:         'Wird geladen...',
        tryAgain:        'Erneut versuchen',
        copy:            'Kopieren',
        share:           'Teilen',
        download:        'Herunterladen',
        upload:          'Hochladen',
        apply:           'Anwenden',
        clear:           'Löschen',
    },

    status: {
        success:         'Erfolgreich!',
        error:           'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
        saved:           'Erfolgreich gespeichert.',
        notFound:        'Seite nicht gefunden.',
        comingSoon:      'Demnächst verfügbar.',
        outOfStock:      'Nicht vorrätig',
        inStock:         'Auf Lager',
        soldOut:         'Ausverkauft',
        new:             'Neu',
        sale:            'Angebot',
        featured:        'Empfohlen',
        noResults:       'Keine Ergebnisse gefunden.',
        required:        'Dieses Feld ist erforderlich.',
        invalidEmail:    'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    },

    shop: {
        addToCart:       'In den Warenkorb',
        addedToCart:     'In den Warenkorb gelegt',
        viewCart:        'Warenkorb anzeigen',
        checkout:        'Zur Kasse',
        continueShopping:'Weiter einkaufen',
        orderSummary:    'Bestellübersicht',
        orderTotal:      'Gesamtbetrag',
        subtotal:        'Zwischensumme',
        shipping:        'Versand',
        tax:             'Steuern',
        discount:        'Rabatt',
        couponCode:      'Gutscheincode',
        applyCoupon:     'Gutschein einlösen',
        quantity:        'Menge',
        price:           'Preis',
        total:           'Gesamt',
        remove:          'Entfernen',
        emptyCart:       'Ihr Warenkorb ist leer.',
        browseProducts:  'Produkte durchsuchen',
        product:         'Produkt',
        products:        'Produkte',
        category:        'Kategorie',
        categories:      'Kategorien',
        sortBy:          'Sortieren nach',
        filterBy:        'Filtern nach',
        allProducts:     'Alle Produkte',
        searchProducts:  'Produkte suchen...',
        productDetails:  'Produktdetails',
        relatedProducts: 'Ähnliche Produkte',
        stockLeft:       'noch auf Lager',
        freeShipping:    'Kostenloser Versand',
        placeOrder:      'Bestellung aufgeben',
        orderConfirmed:  'Bestellung bestätigt!',
        trackOrder:      'Bestellung verfolgen',
        orderNumber:     'Bestellnummer',
        paymentMethod:   'Zahlungsmethode',
        billingAddress:  'Rechnungsadresse',
        shippingAddress: 'Lieferadresse',
        firstName:       'Vorname',
        lastName:        'Nachname',
        email:           'E-Mail-Adresse',
        phone:           'Telefonnummer',
        address:         'Adresse',
        city:            'Stadt',
        province:        'Bundesland / Staat',
        postalCode:      'Postleitzahl',
        country:         'Land',
        secureCheckout:  'Sicherer Checkout',
        payWith:         'Bezahlen mit',
    },

    articles: {
        by:              'Von',
        publishedOn:     'Veröffentlicht am',
        minuteRead:      'Min. Lesezeit',
        tags:            'Tags',
        share:           'Artikel teilen',
        relatedArticles: 'Ähnliche Artikel',
        allArticles:     'Alle Artikel',
        noArticles:      'Keine Artikel gefunden.',
        searchArticles:  'Artikel suchen...',
    },

    search: {
        placeholder:     'Produkte, Artikel, Seiten suchen...',
        results:         'Ergebnisse',
        noResults:       'Keine Ergebnisse gefunden für',
        searching:       'Suche läuft...',
        searchTip:       'Drücken Sie ⌘K oder Ctrl+K zum Suchen',
        quickSearch:     'Schnellsuche',
    },

    newsletter: {
        subscribe:       'Abonnieren',
        subscribeTitle:  'Bleiben Sie auf dem Laufenden',
        subscribeDesc:   'Erhalten Sie die neuesten Updates in Ihr Postfach.',
        emailPlaceholder:'E-Mail eingeben',
        thankYou:        'Vielen Dank für Ihr Abonnement!',
        alreadySubscribed:'Sie sind bereits abonniert.',
        privacyNote:     'Wir respektieren Ihre Privatsphäre. Jederzeit abmelden.',
    },

    footer: {
        rights:          'Alle Rechte vorbehalten.',
        privacy:         'Datenschutzrichtlinie',
        terms:           'Nutzungsbedingungen',
        sitemap:         'Seitenübersicht',
        poweredBy:       'Angetrieben von',
        contactUs:       'Kontaktieren Sie uns',
        followUs:        'Folgen Sie uns',
        quickLinks:      'Schnelllinks',
    },

    forms: {
        email:           'E-Mail',
        password:        'Passwort',
        confirmPassword: 'Passwort bestätigen',
        username:        'Benutzername',
        name:            'Name',
        message:         'Nachricht',
        subject:         'Betreff',
        send:            'Senden',
        sending:         'Wird gesendet...',
        sent:            'Nachricht gesendet!',
        signIn:          'Anmelden',
        signUp:          'Registrieren',
        forgotPassword:  'Passwort vergessen?',
        rememberMe:      'Angemeldet bleiben',
        changePassword:  'Passwort ändern',
        currentPassword: 'Aktuelles Passwort',
        newPassword:     'Neues Passwort',
    },

    i18n: {
        selectLanguage:  'Sprache wählen',
        language:        'Sprache',
    },

    errors: {
        pageNotFound:    'Seite nicht gefunden',
        pageNotFoundDesc:'Die gesuchte Seite existiert nicht oder wurde verschoben.',
        goHome:          'Zur Startseite',
        somethingWrong:  'Etwas ist schiefgelaufen',
        somethingWrongDesc: 'Ein unerwarteter Fehler ist aufgetreten. Ihre Daten sind sicher.',
        returnToStorefront: 'Zurück zum Shop',
    },
};

export default de;
